import React from "react";
import { useTranslation } from "react-i18next";
import { MessageVariant } from "src/shared/enums/messageTypes/messageTypes";

export default function useGetStatusTitle(status: number) {
  const { t } = useTranslation();

  const statusEnum: {
    [key: string]: { title: string; variant: MessageVariant };
  } = {
    "0": {
      title: t("Εκκρεμεί"),
      variant: MessageVariant.Warning,
    },
    "1": {
      title: t("Η αναντιστοιχία έχει επιλυθεί"),
      variant: MessageVariant.Success,
    },
    "2": {
      title: t("Ολοκληρώθηκε με εφαρμογή αλλαγής"),
      variant: MessageVariant.Success,
    },
    "3": {
      title: t("Ολοκληρώθηκε χωρίς εφαρμογή αλλαγής"),
      variant: MessageVariant.Success,
    },
    "4": {
      title: t("Ακυρώθηκε"),
      variant: MessageVariant.Error,
    },
  };

  return statusEnum[status.toString()];
}
